<template>
  <div class="head_con" id="header" ref="header">
    <div class="head">
      <div class="logo">
        <img v-if="isLogo" src="../../src/assets/bai_logo.png" alt="" style="width: 200px;" />
        <img v-else src="../../src/assets/index1.png" alt="" style="width: 200px;" />
      </div>
      <div class="tabs">
        <el-tabs type="border-card" v-model="activeName" @tab-click="handleClick">
          <el-tab-pane v-for="item in tabsDate" :key="item.name" :label="item.label" :name="item.name">
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>

    <div class="m-navbar" v-if="nav"></div>
    <transition name="nav">
      <div class="m-navba" v-if="nav">
        <div @click="getNavCons" class="del_top">
          <div></div>
          <!-- <img src="../../src/assets/index2.png" alt="" /> -->
          <i class="el-icon-close"></i>
        </div>
        <div class="tabs tabs1">
          <el-tabs tabPosition="right" type="border-card" v-model="activeName" @tab-click="handleClick">
            <el-tab-pane v-for="item in tabsDate" :key="item.name" :label="item.label" :name="item.name">
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </transition>
    <div class="head_h5">
      <div class="logo_h5">
        <img src="../../src/assets/index2.png" alt="" style="width: 100px;" />
        <i class="el-icon-s-unfold" @click="getNav"></i>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      nav: false,
      activeName: "homes",
      isLogo: false,
      tabsDate: [
        {
          label: "首页",
          name: "homes",
          path: "/home",
        },
        {
          label: "合作案例",
          name: "cooperations",
          path: "/cooperation",
        },
        {
          label: "设备",
          name: "equipments",
          path: "/equipment",
        },
        {
          label: "关于我们",
          name: "abouts",
          path: "/about",
        },
        {
          label: "公告信息",
          name: "notices",
          path: "/notices",
        },
        {
          label: "登录",
          name: "logins",
        },
      ],
    };
  },
  created() {
    if (document.querySelectorAll('.fixed')) {
      this.isLogo = false;
    }
  },
  mounted() {
    window.addEventListener('scroll', () => {
      let top = document.documentElement.scrollTop || document.body.scrollTop || window.pageYOffset
      if (top > 200) {
        document.getElementById("header").classList.remove('fixedNone')
        document.getElementById("header").classList.add('fixed')
        this.isLogo = false;
      }
      if (top < 100) {
        document.getElementById("header").classList.remove('fixed')
        document.getElementById("header").classList.add('fixedNone')
        if (this.activeName == 'about') {
          this.isLogo = true;
        }
      }
    })
    this.activeName = localStorage.getItem('activeName') ? localStorage.getItem('activeName') : 'homes';
    // this.activeName = this.tabsDate[item.index].name;
    // this.$router.push({
    //   path: '/home',
    // }, () => { }, () => { })
  },
  methods: {
    handleClick(item, event) {
      if (this.$route.path === this.tabsDate[item.index].path) {
        return;
      }
      if (item.name == 'logins') {
        // window.open('https://admin.hongnx.com')
        location.href = "https://uatadmin.hongnx.com"
      }
      if (item.name == 'about' && document.querySelectorAll('.fixedNone')) {
        this.isLogo = true;
      } else {
        this.isLogo = false;
      }
      this.activeName = this.tabsDate[item.index].name;
      localStorage.setItem('activeName', this.activeName)
      this.$router.push({ path: this.tabsDate[item.index].path });
      this.nav = false;
      this.$emit('labelName', item.label)
      // document.getElementsByTagName("html")[0].style = "overflow:scroll";
      document.documentElement.scrollTop = 0
    },
    getNav() {
      this.nav = true;
      if (this.nav) {
        document.getElementsByTagName("html")[0].style = "overflow:hidden";
      } else if (!this.nav) {
        document.getElementsByTagName("html")[0].style = "overflow:scroll";
      }
    },
    getNavCons() {
      this.nav = false;
      if (this.nav) {
        document.getElementsByTagName("html")[0].style = "overflow:hidden";
      } else if (!this.nav) {
        document.getElementsByTagName("html")[0].style = "overflow:scroll";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.head_h5 {
  display: none;
  position: fixed;
  z-index: 100;
  width: 100%;
  top: 0;

  .logo_h5 {
    // height: 100px;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 20px;
  }

  .tabs1 {
    width: 88% !important;
  }

  .tabs {
    position: absolute;
    z-index: 100;
    position: absolute;
    background: rgba(0, 0, 0, .8);
    width: 100%;
    left: -100%;
    top: 0;
    height: 100%;
    max-height: 100%;
    overflow: hidden;
    z-index: 100;
  }
}


.head {
  animation: fadenum 2s;
}

@keyframes fadenum {

  0% {
    transform: translateY(-150px);
  }

}

.head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: absolute;
  z-index: 100;
  width: 100%;
  height: 5.375rem;
  padding: 0 3.5rem 0 7.5rem;
  // background: #fff;
}

:deep(.el-tabs--border-card > .el-tabs__content) {
  padding: 0;
}

:deep(.el-tabs--border-card > .el-tabs__header .el-tabs__item.is-active) {
  height: 100%;
}

:deep(.el-tabs--border-card > .el-tabs__header .el-tabs__item) {
  // width: 8.25rem;
  // height: 2.5rem;
  // padding: 5px 0;
  height: 100%;
  text-align: center;
  font-size: 1.125rem;
  color: #333333;
  font-weight: bold;
  margin-left: 2rem;
  border: none;
}
:deep(.el-tabs__item:nth-child(6)){
  background: #0e6eb8 !important;
  color: #fff !important;
  padding: 0 20px;
  width: 7.25rem;
  height: 2.5rem;
  border-radius: 6px;
  margin-left: 32px !important;
}

:deep(.el-tabs--border-card > .el-tabs__header) {
  // background-color: #ffffff;
  border-bottom: none;
}
:deep(.el-tabs--border-card>.el-tabs__header .el-tabs__item:not(.is-disabled):hover){
  color: #0E6EB8;
}
:deep(.el-tabs--border-card > .el-tabs__header .el-tabs__item.is-active) {
  // background: #0e6eb8;
  font-size: 1.125rem;
  color: #0E6EB8;
  // border-bottom: 4px solid #0E6EB8;
  border-radius: 50%;
  background: none !important;
  border: none !important;
  padding: .625rem 1.25rem;
  &::before {
        content: "";
        //width: 3.0625rem;
        width: -webkit-fill-available;
        height: .25rem;
        background: #0E6EB8;
        border-radius: 0.125rem;
        display: flex;
        position: absolute;
        z-index: -1;
        left: 0;
        bottom: 0;
      }
}
.el-tabs--border-card {
  background: none;
  border: none;
  box-shadow: none;
}

// h5yanghsi
/* 遮罩层 */
.m-navbar {
  position: fixed;
  left: -3px;
  top: 0;
  bottom: 0;
  right: 0;
  background-color: #000;
  opacity: 0.5;
  z-index: 100;
  overflow-y: hidden;
  overflow-x: hidden;
}

.del_top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 80px;
  padding: 0 10px;

  &>img {
    width: 100px;
    height: 50px;
  }
}

/* 存放弹框内容 */
.m-navba {
  position: fixed;
  // left: 100px;
  right: 0;
  top: 0;
  bottom: 0;
  background-color: #fff;
  z-index: 1000;
  // overflow-y:hidden;
  // overflow-x: hidden;
  width: 20%;
  height: 100%;
}

.nav-leave {
  transform: translateX(0px);
}

.nav-leave-active {
  transition: all 0.4s ease;
}

.nav-leave-to {
  transform: translateX(600px);
}

.nav-enter {
  transform: translateX(600px);
}

.nav-enter-active {
  transition: all 0.4s ease;
}

.nav-enter-to {
  transform: translateX(0px);
}

// 头部固定
.fixed {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 4.375rem;
  position: fixed;
  top: 0;
  background-color: #fff;
  z-index: 9999;
  animation: fadenum 1s;
  box-shadow: 0px 0px 2rem 0px rgba(1, 20, 35, 0.08);

  @keyframes fadenum {

    0% {
      transform: translateY(-150px);
    }

  }
}

.fixedNone {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 5.375rem;
  position: absolute;
  z-index: 9999;
  animation: fadenum1 1s;
  //   @keyframes fadenum1 {

  //   0% {
  //     transform: translateY(-.625rem);
  //   }
  // }
}
</style>
<style lang="scss">
@media screen and (max-width: 600px) {
  .fixed {
    animation: fadenum 1s;
  }

  @keyframes fadenum {

    0% {
      transform: none !important;
    }

  }
}
</style>
